import * as React from 'react';
import SVGInline from 'react-svg-inline';

import Card from './Card';

import styles from './Card.scss';

interface CardWithIconProps {
  icon: string;
  className?: string;
}

const CardWithIcon: React.SFC<CardWithIconProps> = ({ children, icon, className }) => (
  <Card className={className}>
    <div className="d-flex align-items-center py-3 px-4">
      <SVGInline svg={icon} className={styles.icon} />
      <div>{children}</div>
    </div>
  </Card>
);

export default CardWithIcon;



// WEBPACK FOOTER //
// /www/client/src/components/Card/CardWithIcon.tsx